import { render, staticRenderFns } from "./carUserList.vue?vue&type=template&id=48480d73&scoped=true&"
import script from "./carUserList.vue?vue&type=script&lang=js&"
export * from "./carUserList.vue?vue&type=script&lang=js&"
import style0 from "./carUserList.vue?vue&type=style&index=0&id=48480d73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48480d73",
  null
  
)

export default component.exports